import { useState } from "react";
import styled from "styled-components";

import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  Container,
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";
import { Switch } from "@material-ui/core";
import DigitalSignature from "./DigitalSignature";
import RequiestStatusModal from "./modals/RequiestStatusModal";
import { putConsent } from "../services/consent";
import SharedModal from "./shared/SharedModal";
import { pagesUrl, redirectPage } from "../utils/misc";

const Main = styled(Container)`
  padding: 30px;
`;

const options = [
  {
    name: "Enfermedad cardiovascular",
    field_name: "has_cardiovascular_disease",
  },
  {
    name: "Asma",
    field_name: "asthma",
  },
  {
    name: "Obesidad",
    field_name: "obesity",
  },
  {
    name: "Diabetes",
    field_name: "diabetes",
  },
  {
    name: "Hipertensión Arterial",
    field_name: "arterial_hypertension",
  },
  {
    name: "Tabaquismo",
    field_name: "smoking",
  },
  {
    name: "Cáncer",
    field_name: "cancer",
  },
  {
    name: "Enfermedad inmunosupresora",
    field_name: "immunosuppressive_disease",
  },
];

const inputProps = {
  style: {
    transform: "translateY(-10%)",
    width: 300,
  },
};

export default function ConsentForm({ agreementId, member, brandId }) {
  const { handleSubmit, control, reset, errors } = useForm();
  const [adultSignature, setAdultSignature] = useState();
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");

  const currentBrand = localStorage.getItem("current_brand");

  const onSubmit = async (data) => {
    for (const key in data) {
      if (typeof data[key] !== "string") {
        if (data[key]) {
          data[key] = 1;
        } else {
          data[key] = 0;
        }
      }
    }
    data["signature_adult"] = adultSignature;
    data["agreement_line_uuid"] = agreementId;
    data["name_under_age"] = member?.first_name + " " + member.last_name;
    data["document_under_age"] = member?.document_number;

    try {
      const response = await putConsent(data);
      if (response.data.status === "success") {
        setCurrentStatus("CONSENTIMIENTO FIRMADO CORRECTAMENTE");
        redirectPage(pagesUrl[currentBrand]);
      } else {
        const message = response.data.message[0].message;
        setCurrentStatus(
          message != null
            ? message.toUpperCase()
            : "NO SE PUDO FIRMAR EL CONSENTIMIENTO"
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setShowStatusModal(true);
    }
  };

  return (
    <Main maxWidth={"md"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display={"flex"} justifyContent={"center"}>
              <Typography variant={"title"} color={"primary"} align="center">
                {"CONSENTIMIENTO INFORMADO"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              Yo,{" "}
              <Controller
                rules={{ required: true }}
                control={control}
                name={"adult_name"}
                render={({ field }) => (
                  <TextField
                    {...field}
                    {...inputProps}
                    type="text"
                    variant="standard"
                    placeholder={"Nombre del adulto"}
                    onChange={(e) => field.onChange(e.target.value)}
                    inputProps={{
                      style: { padding: " 2px 10px " },
                    }}
                  />
                )}
              />
              identificado{" "}
              <Controller
                rules={{ required: true }}
                control={control}
                name={"document_adult"}
                render={({ field }) => (
                  <TextField
                    {...field}
                    {...inputProps}
                    type="text"
                    variant="standard"
                    placeholder={"Documento del adulto"}
                    onChange={(e) => field.onChange(e.target.value)}
                    inputProps={{
                      style: { padding: " 2px 10px " },
                    }}
                  />
                )}
              />{" "}
              , mayor de edad y en calidad de representante legal del menor{" "}
              <span style={{ fontWeight: "700" }}>
                {" "}
                {member.first_name} {member.last_name}{" "}
              </span>
              , identificado con documento de identidad{" "}
              <span style={{ fontWeight: "700", color: "black" }}>
                #{member.document_number}{" "}
              </span>
              , quien se llamará en adelante “el Menor”, por medio de este
              documento, autorizo al “Menor” para ingresar como afiliado(a) al
              Centro Médico Deportivo de Acondicionamiento Físico{" "}
              <b> {['1', '3'].includes(currentBrand) ? "Bodytech" : "Athletic"} </b> a hacer uso de
              los servicios que acá se prestan.
              <br />
              <br />
              Declaro conocer los riesgos que implican la práctica del
              entrenamiento deportivo para un menor de edad y garantizo que el
              “Menor” seguirá estrictamente las indicaciones de los
              Entrenadores, Profesionales de la salud y el reglamento general de
              servicios de Centro Médico Deportivo de Acondicionamiento Físico{" "}
              <b>{currentBrand === "1"  || currentBrand === "3" ? "Bodytech" : "Athletic"}</b> , el cual se
              encuentra detallado en el Contrato de Prestación de Servicios
              suscrito entre <b>{currentBrand === "1" || currentBrand === "3"  ? currentBrand === "3" ? "Inverdesa Perú S.A.C." :"Bodytech" : "Athletic"} </b> y
              yo, actuando en calidad de representante legal del Menor.
              <br />
              <br />
              Responder Si / No según el caso si el menor de edad ha tenido las
              siguientes enfermedades
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  {options?.map((option, idx) => (
                    <Grid item xs={12} key={idx}>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Typography fontSize={"12px"}>{option.name}</Typography>
                        <Box
                          display={"flex"}
                          justifyContent={"flex-end"}
                          alignItems={"center"}
                        >
                          <Typography fontSize={"12px"}>{"No"}</Typography>
                          <Box mx={1}>
                            <Controller
                              control={control}
                              name={option.field_name}
                              render={({ field }) => (
                                <Switch color="secondary" {...field} />
                              )}
                            />
                          </Box>
                          <Typography fontSize={"12px"}>{"Si"}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="caption">{"Firma del adulto"}</Typography>
            <DigitalSignature setSignature={setAdultSignature} />
          </Grid>

          <Grid item xs={12}>
            <Button
              disabled={!adultSignature}
              type="submit"
              fullWidth
              variant="contained"
            >
              {"Aceptar"}
            </Button>
          </Grid>
        </Grid>
      </form>

      {showStatusModal && (
        <SharedModal
          isOpen={showStatusModal}
          modalBody={
            <Box display={"flex"} justifyContent={"center"}>
              <RequiestStatusModal
                handleClose={setShowStatusModal}
                requestStatus={currentStatus}
              />
            </Box>
          }
        />
      )}
    </Main>
  );
}
